var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVariablesActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#variables-active_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "variables-active_svg__b",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M24 0H0v24h24z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#variables-active_svg__b)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "variables-active_svg__c",
    width: 22,
    height: 21,
    x: 1,
    y: 2,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M23 2H1v20.07h22z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#variables-active_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00F2B6",
    d: "M7.48 9.36c-.25-.25-.33-.58-.17-.72l1.25-1.25c.15-.15.48-.07.72.18l2.68 2.68 2.68-2.68c.25-.25.58-.32.72-.17l1.25 1.25c.15.15.08.47-.17.72l-2.68 2.68 2.68 2.68c.22.22.31.5.22.67l-.04.06-1.25 1.25c-.15.15-.48.07-.72-.17l-2.68-2.68-2.68 2.68c-.25.25-.58.33-.72.18l-1.25-1.25c-.15-.15-.08-.47.17-.72l2.68-2.68-2.68-2.68z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.73 22.08H1.87c-.12 0-.23-.02-.34-.07a.9.9 0 0 1-.29-.19.93.93 0 0 1-.26-.62V2.87c0-.11.02-.23.06-.34.05-.11.11-.21.2-.29s.18-.15.3-.19c.11-.04.23-.06.34-.06h3.86c.12 0 .23.02.34.07.11.04.2.11.28.19s.14.18.19.29c.04.11.06.22.06.34v.99c0 .12-.02.23-.07.34s-.11.2-.19.29c-.08.08-.18.15-.29.19-.11.05-.25.06-.34.07h-.96l-.08.06v14.46l.07.08.98.01c.23 0 .45.1.62.27.16.16.25.38.25.62v.97a.87.87 0 0 1-.26.62c-.08.08-.18.14-.28.19-.11.04-.22.07-.34.07zM1.86 2.79h-.03L1.78 21.2l.08.08h3.86l.08-.08v-.96l-.07-.08-.98-.01a.87.87 0 0 1-.86-.88V4.82c0-.24.1-.46.27-.62.16-.16.38-.25.61-.25h.97l.08-.08v-.99l-.07-.09zm16 19.29h3.86c.12 0 .23-.02.34-.07.11-.04.2-.11.29-.19a.93.93 0 0 0 .26-.62V2.87c0-.11-.02-.23-.06-.34a.8.8 0 0 0-.2-.29.9.9 0 0 0-.3-.19c-.11-.04-.23-.06-.34-.06h-3.86c-.12 0-.23.02-.34.07-.11.04-.2.11-.28.19s-.14.18-.19.29c-.04.11-.06.22-.06.34v.99c0 .12.02.23.07.34s.11.2.19.29c.08.08.18.15.29.19.11.05.25.06.34.07h.96l.08.06v14.46l-.07.08-.98.01c-.23 0-.45.1-.62.27-.16.16-.25.38-.25.62v.97a.87.87 0 0 0 .26.62c.08.08.18.14.28.19.11.04.22.07.34.07zm3.87-19.29h.03l.05 18.41-.08.08h-3.86l-.08-.08v-.96l.07-.08.98-.01a.87.87 0 0 0 .86-.88V4.82c0-.24-.1-.46-.27-.62a.86.86 0 0 0-.61-.25h-.97l-.08-.08v-.99l.07-.09z"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "variables-active_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVariablesActive);
export default __webpack_public_path__ + "static/media/variables-active.b3e6a0160031327b25e3d146871d8b29.svg";
export { ForwardRef as ReactComponent };